<script lang="ts">
    import cx from 'classnames';
    import LazyIcon from '$lib/components/LazyIcon/LazyIcon.svelte';
    import type { TNavItem } from './types';
    import { getContext } from 'svelte';
    import { BAR_CONTEXT } from './constants';
    import RedDot from '$src/lib/components/Badge/RedDot.svelte';

    export let item: TNavItem;
    $: ({ href, selected, icon, iconActive, text, buttonBarText, testid, hasNotification } = item);

    $: iconToRender = selected && iconActive ? iconActive : icon;

    const currentBar = getContext(BAR_CONTEXT);
</script>

<a
    {href}
    class={cx(
        'flex flex-shrink-0 flex-col items-center justify-center',
        'relative top-[-8px] tablet:static tablet:mt-2xs',
        'h-[72px] w-[80px] tablet:w-[112px] desktop-l:h-[88px] desktop-l:w-[120px]',
        'bg-no-repeat text-white',
        {
            selected: selected,
            'pointer-events-none': selected
        }
    )}
    data-testid={`${currentBar}-${testid}`}
>
    <div class="flex w-full flex-col items-stretch justify-center align-middle">
        <div class="flex w-full items-center justify-center">
            <span
                class="relative flex h-lg w-lg justify-center text-white desktop-l:h-xl desktop-l:w-xl"
            >
                {#if hasNotification}<RedDot />{/if}
                <LazyIcon icon={iconToRender} />
            </span>
        </div>
        <div class="flex w-full items-center justify-center">
            <span
                class={cx('flex items-center justify-center text-xs desktop-l:text-sm', {
                    'text-white': selected,
                    'text-purple-0': !selected
                })}
            >
                {buttonBarText || text}
            </span>
        </div>
    </div>
</a>

<style lang="postcss">
    /* BACKGROUND IMAGES */
    .selected {
        @apply bg-[url('./assets/backgrounds/item-navigation-selected-mobile.svg')] bg-center;
    }
    @screen tablet {
        .selected {
            @apply bg-[url('./assets/backgrounds/item-navigation-selected-default.svg')];
        }
    }
    @screen desktop-l {
        .selected {
            @apply bg-[url('./assets/backgrounds/item-navigation-selected-large.svg')];
        }
    }
</style>
